<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        md="8"
        cols="12"
      >
        <material-card
          :key="updateKey"
          :loading="loading"
          color="primary"
        >
          <template v-slot:header>
            <v-tabs
              v-model="tab"
              grow
              slider-color="secondary"
              background-color="primary"
            >
              <v-tab
                v-for="(language, i) in languages"
                :key="i"
                active-class="secondary--text"
                @click="() => setTranslations(i)"
              >
                {{ language.name }}
              </v-tab>
            </v-tabs>
            <v-menu
              v-if="isBetaCore(user)"
              bottom
              left
              offset-y
              transition="slide-y-transition"
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  class="toolbar-items"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="secondary">
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-list
                  dense
                >
                  <v-list-item
                    @click="() => onAddSelect(tab)"
                  >
                    <v-list-item-title>
                      Add Language
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="languages[tab]"
                    @click="() => onEditSelect(tab)"
                  >
                    <v-list-item-title>
                      Edit Language
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="languages[tab]"
                    @click="() => onAddKey(tab)"
                  >
                    <v-list-item-title>
                      Add Translation
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </template>
          <v-alert
            v-show="languages.length === 0 && !loading"
            type="warning"
          >
            No languages found for the current site
          </v-alert>
          <editable-table
            v-if="languages[tab]"
            :deletable="isBetaCore(user)"
            :headers="headers"
            :items="translations"
            @save="saveTranslation"
          />
          <template v-slot:actions>
            <v-btn
              :loading="saving"
              color="primary"
              @click="saveLanguages"
            >
              Save Changes
            </v-btn>
            <build />
          </template>
        </material-card>
      </v-col>
    </v-row>
    <form-dialog
      ref="dialog"
      :title="currentTitle"
      :schema="currentSchema"
      :item="currentItem"
      @submit="currentMethod"
    />
  </v-container>
</template>

<script>
  import EditableTable from '../components/core/EditableTable.vue'
  import FormDialog from '../components/core/FormDialog.vue'
  import Build from '../components/core/Build.vue'
  export default {
    components: {
      EditableTable,
      FormDialog,
      Build,
    },
    data () {
      return {
        tab: 0,
        error: null,
        loading: false,
        saving: false,
        currentTitle: '',
        currentItem: {},
        currentMethod: () => {},
        currentSchema: {},
        translations: [],
        translationSchema: {
          key: {
            type: 'text',
            label: 'Key'
          },
          value: {
            type: 'text',
            label: 'Value'
          }
        },
        languageSchema: {
          code: {
            type: 'text',
            label: 'Code'
          },
          iso: {
            type: 'text',
            label: 'ISO'
          },
          name: {
            type: 'text',
            label: 'Name'
          },
          dir: {
            type: 'select',
            label: 'Direction',
            items: ['ltr', 'rtl']
          },
          stringified_translations: {
            type: 'text',
            label: 'Translations (Leave empty for no change)'
          }
        },
        headers: [{
          text: 'Key',
          align: 'left',
          value: 'key',
        }, {
          text: 'Value',
          align: 'left',
          value: 'value',
          editable: true
        }],
        languages: [],
        updateKey: 0
      }
    },
    computed: {
      user: function () {
        return this.$store.state.user
      },
      site: function () {
        return this.$store.state.site
      }
    },
    mounted () {
      if (this.isBetaCore(this.user)) {
        this.headers[0].editable = true
      }
      this.getLanguages()
    },
    methods: {
      setTranslations (tab) {
        var translations = []
        if (this.languages[tab] && this.languages[tab].translations) {
          translations = this.fillTranslations(this.languages[tab].translations, translations)
        }
        this.translations = translations
        this.updateKey++
      },
      fillTranslations (obj, items, parent = '') {
        Object.keys(obj).forEach(key => {
          var value = obj[key]
          if (this.isObject(value)) {
            this.fillTranslations(value, items, parent + key + '.')
          } else {
            items.push({
              key: parent + key,
              value
            })
          }
        })
        return items
      },
      isObject (item) {
        return (item && typeof item === 'object' && !Array.isArray(item))
      },
      onEditSelect () {
        this.currentTitle = 'Edit Translation'
        this.currentSchema = this.languageSchema
        this.currentMethod = this.updateLanguage
        this.currentItem = this.languages[this.tab]
        this.$refs.dialog.open()
      },
      onAddSelect () {
        this.currentTitle = 'Add Translation'
        this.currentSchema = this.languageSchema
        this.currentMethod = (submit) => this.updateLanguage(submit, true)
        this.$refs.dialog.open()
      },
      onAddKey () {
        this.currentTitle = 'Add Translation'
        this.currentSchema = this.translationSchema
        this.currentMethod = this.addKey
        this.$refs.dialog.open()
      },
      updateLanguage (submit, add = false) {
        var language = submit.item
        if (language.stringified_translations) {
          try {
            var json = language.stringified_translations
            language.translations = JSON.parse(json)
          } catch (e) {
            console.log(e)
          }
        }
        delete language.stringified_translations
        if (add) {
          this.languages.push(language)
          this.tab++
        } else {
          this.languages[this.tab] = language
        }
        this.setTranslations(this.tab)

        submit.done()
      },
      addKey (submit) {
        var translations = []
        translations = this.fillTranslations(this.languages[this.tab].translations, translations)
        translations.push(submit.item)
        this.saveTranslation(translations)
        submit.done()
        this.updateKey++
      },
      saveTranslation (items) {
        var objects = []
        items.forEach(item => {
          var object = this.createObject(item.key, item.value)
          objects.push(object)
        })
        var translation = {}
        this.mergeDeep(translation, ...objects)
        this.languages[this.tab].translations = translation
        this.updateKey++
      },
      createObject (key, value) {
        var obj = {}
        var parts = key.split('.')
        if (parts.length === 1) {
          obj[parts[0]] = value
        } else if (parts.length > 1) {
          // concat all but the first part of the key
          var remainingParts = parts.slice(1, parts.length).join('.')
          obj[parts[0]] = this.createObject(remainingParts, value)
        }
        return obj
      },
      mergeDeep (target, ...sources) {
        if (!sources.length) return target
        const source = sources.shift()

        if (this.isObject(target) && this.isObject(source)) {
          for (const key in source) {
            if (this.isObject(source[key])) {
              if (!target[key]) Object.assign(target, { [key]: {} })
              this.mergeDeep(target[key], source[key])
            } else {
              Object.assign(target, { [key]: source[key] })
            }
          }
        }

        return this.mergeDeep(target, ...sources)
      },
      saveLanguages () {
        this.saving = true
        this.api.post('language/' + this.site, this.languages)
          .then(result => {
            this.languages = result.data
            this.updateKey++
            this.saving = false
          }, error => {
            this.error = error
            this.saving = false
          })
      },
      getLanguages () {
        this.loading = true
        this.api.get('language/' + this.site)
          .then(result => {
            this.languages = result.data
            if (this.languages.length > 0) {
              this.setTranslations(this.tab)
            } else {
              this.updateKey++
            }
            this.loading = false
          }, error => {
            this.error = error
            this.loading = false
          })
      }
    }

  }
</script>
